<template>
	<div
        v-if="showFilter"
		:class="quickFilterClass()">
		<div v-if="!mobile" :class="['content__label', {filterApplied:selectedQuickFilter}, {open:openState}]">
			<h4  class="body-1">{{selectedQuickFilter}}</h4>
		</div>
		<div :class="['quick-filters__content', {filterApplied:selectedQuickFilter}, {open:openState}]">
			<div class="content__menu" v-if="this.$router.currentRoute.name === 'jobs-manage'">
				<div
					v-for="item in filterListManageSubset"
					:key="generateUniqueHash(item)"
					:class="['menu__item', (item.name === selectedQuickFilter) ? 'selected' : '']"
					@click="setQuickFilter(item,false)">
					<span class="body-2 label">{{item.name}}</span>
				</div>
			</div>
            <div class="content__menu" v-if="this.$router.currentRoute.name === 'jobs-requests'">
                <div
                        v-for="item in filterListRequestSubset"
                        :key="generateUniqueHash(item)"
                        :class="['menu__item', (item.name === selectedQuickFilter) ? 'selected' : '']"
                        @click="setQuickFilter(item,false)">
                    <span class="body-2 label">{{item.name}}</span>
                </div>
            </div>
			<div
				class="content__menu-btn"
				@click="toggleMenuOpenState">
				<v-icon
					size="28"
					class="white--text">
					{{ getMenuArrow }}
				</v-icon>
			</div>
		</div>

        <v-tooltip
                top
                open-delay="400"
				:disabled="mobile">
            <v-btn
                    fab depressed small
                    color="primary"
                    slot="activator"
                    :class="['quick-filters__button', {filterApplied:selectedQuickFilter}]"
                    @click="toggleMenuOpenState">
                <v-icon
                        size="22">
                    flash_on
                </v-icon>
            </v-btn>
            <span class="grey--text text--lighten-3">Quick Filters</span>
        </v-tooltip>


		<v-dialog
				v-if="mobile"
				fullscreen
				hide-overlay
				transition="dialog-bottom-transition"
				v-model="overlayOpenState">

		      <v-card color="#0D47A1">
				<v-toolbar color="#0D47A1" dark flat>
						<v-icon size="22">flash_on</v-icon>
						<span class="white--text label">Quick Filters</span>
						<v-spacer></v-spacer>
				  		<v-btn
							dark fab small
							depressed flat
							@click.stop="toggleMenuOpenState">
							<v-icon size="22">close</v-icon>
						</v-btn>
				</v-toolbar>
				<v-layout  v-if="this.$router.currentRoute.name === 'jobs-manage'" column fill-height >
						<div v-for="item in filterListManageSubset"
							:key="generateUniqueHash(item)">
						<v-card-actions class="justify-center">
						<v-btn
							:class="[(item.name === selectedQuickFilter) ? 'blue--text text--darken-4' : '']"
							:outline="item.name!==selectedQuickFilter" color="white" small block
							@click.stop="setQuickFilter(item,false),toggleMenuOpenState">
							{{item.name}}
						</v-btn>
						</v-card-actions>
						</div>
				</v-layout>
						<v-layout v-if="this.$router.currentRoute.name === 'jobs-requests'" column fill-height >
						<div v-for="item in filterListRequest"
							:key="generateUniqueHash(item)">
						<v-card-actions class="justify-center">
						<v-btn
							:class="[(item.name === selectedQuickFilter) ? 'blue--text text--darken-4' : '']"
							:outline="item.name!==selectedQuickFilter" color="white" small block
							@click.stop="setQuickFilter(item,false),toggleMenuOpenState">
							{{ item.name }}
						</v-btn>
						</v-card-actions>
						</div>
				</v-layout>
			  </v-card>
		</v-dialog>

        <div v-if="showSearch" class="applied-search-term">
            <span class="txt">Search Applied:</span>
            <v-chip
                    class="ma-2" color="primary"
                    close dark
                    @input="clearSearchTerms()"
            >{{getSearchTerms()}}</v-chip>
        </div>
	</div>
</template>


<script>
	import { mapState, mapActions, mapGetters } from 'vuex'
	import {
		VUEX_JOBS_APPLY_QUICK_FILTER,
		VUEX_JOBS_APPLY_DEEPSTATE,
        VUEX_JOBS_CLEAR_FILTERS,
        VUEX_JOBS_RESET_FILTERS
	} from '@/store/constants/jobs'

	import {
		VUEX_UI_HIDE_QUICK_FILTER_OVERLAY,
		VUEX_UI_SHOW_QUICK_FILTER_OVERLAY
	} from '@/store/constants/ui'

	export default {
		name: 'quick-filters',

		data:() => ({
			openState: false,
			selectedQuickFilter: null,

            filterListManage: [
				{
					name: 'Active',
					value: 1
				},
				{
					name: 'Pending',
					value: 2
				},
				{
					name: 'In Production',
					value: 3
				},
				{
					name: 'In Design',
					value: 4
				},
				{
                    name: 'Comps',
                    value: 10
                },
				{
					name: 'Due Today',
					value: 5
				},
				{
					name: 'Late',
					value: 6
				}
			],
            filterListRequest: [
                {
                    name: 'Pending Approval',
                    value: 7
                },
                {
                    name: 'Pending Print Approval',
                    value: 8
                },
                {
                    name: 'Pending Package Approval',
                    value: 12
                },
                {
                    name: 'All My Requests',
                    value: 9
                },
                {
                    name: 'All Requests',
                    value: 11
                }
            ],
		}),

		computed: {
			...mapState({
                appliedFilters: state => state.jobs.appliedFilters,
				jobsFilterToggler: state => state.jobs.filterToggler,
				mobile: state => state.mobile.mobile,
				overlayOpenState: state => state.ui.quickFilterOverlay.openState,
			}),

            ...mapGetters({
                currentUserHasRole: 'currentUserHasRole',
            }),

            getMenuArrow() { return this.openState ? 'arrow_left' : 'arrow_right' },

            filterListManageSubset() {
                var res = []
                for (var i in this.filterListManage) {
                    //show it
                    var doPush = true

                    //except don't show pending, unless one of these 5 roles
                    if (this.filterListManage[i].value === 2) {
                        doPush = false
                        if (
                            this.currentUserHasRole(SILA_ROLE_JOBS_EXECUTIVE)
                            || this.currentUserHasRole(SILA_ROLE_JOBS_PRINT_APPROVER)
                            || this.currentUserHasRole(SILA_ROLE_JOBS_PROJECT_MANAGER)
                            || this.currentUserHasRole(SILA_ROLE_JOBS_PRINT_PROJECT_MANAGER)
                            || this.currentUserHasRole(SILA_ROLE_JOBS_PREMEDIA_PROJECT_MANAGER)
                            || this.currentUserHasRole(SILA_ROLE_JOBS_REQUESTOR)
                        ) {
                            doPush = true
                        }
                    }
                    if (doPush) res.push(this.filterListManage[i]);
                }
                return res
            },

            filterListRequestSubset() {
                var res = []
                for (var i in this.filterListRequest) {
                    //show it
                    var doPush = true

                    if (this.filterListRequest[i].value == 9) {
                        //All My Requests -- hide from admins
                        if ( this.isManagers() ) {
                            doPush = false
                        }
                    } else if (this.filterListRequest[i].value == 11) {
                        //All Requests -- show only to admins
                        doPush = false
                        if ( this.isManagers() ) {
                            doPush = true
                        }
                    }

                    if (doPush) res.push(this.filterListRequest[i]);
                }
                return res
            },

            showFilter() {
                //always show now for everyone - but might hide this later so leaving old logic for now
                return true

                /*
                //always show for jobs, and sometimes for requests
                if (this.$router.currentRoute.name === 'jobs-manage') {
                    return true
                } else {
                    if (this.currentUserHasRole(SILA_ROLE_JOBS_EXECUTIVE) ||
                        this.currentUserHasRole(SILA_ROLE_JOBS_PRINT_APPROVER)) {
                        return true
                    } else {
                        return false
                    }
                }
                 */
            },
            showSearch() {
                let ret = false
                let idx = this.appliedFilters.findIndex(x => x.filterOn === 'searchTerms')
                if (idx > -1) {
                    ret = (this.appliedFilters[idx]['value'] !== '')
                }
                return ret
            }
		},

		mounted() {
            //indicate that quick filters are changing
            this.$store.dispatch('VUEX_JOBS_SET_FILTER_TOGGLER', { value: "quick"+Date.now()})

            //check deeplink
            var deepstorage = []
            if (this.$router.currentRoute.name === 'jobs-manage') {
                deepstorage = this.$store.getters.getPersistence('jobs')
            } else {
                deepstorage = this.$store.getters.getPersistence('requests')
            }

            //kill current setup
            this.removeCurrentQuickFilter();

            //do quick filter
            var doQuickFilter = true;
            if (deepstorage) {
                doQuickFilter = false;
            }

            //if no deep link, begin with quick filter
            if (doQuickFilter) {
                //never been deep linked
                this.applyDefaultQuickFilter()
            } else {
                //deeplink
                if (deepstorage.currentQuickFilter && deepstorage.currentQuickFilter.hasOwnProperty('name')) {
                    //trigger quick filter
                    this.setQuickFilter({
                        name: deepstorage.currentQuickFilter.name,
                        value: deepstorage.currentQuickFilter.value
                    }, true)
                } else {
                    //apply manual deep state
                    this.applyDeepstate(deepstorage);
                }

            }
		},

        watch: {
            jobsFilterToggler: function(newValue) {
                if (newValue === 'manual') {
                    //a manual filter was applied
                    this.removeCurrentQuickFilter();
                }
            }
        },

		methods: {
			...mapActions({
				'applyQuickFilter': VUEX_JOBS_APPLY_QUICK_FILTER,
                'clearQuickFilters': VUEX_JOBS_CLEAR_FILTERS,
				'resetQuickFilters': VUEX_JOBS_RESET_FILTERS,
				'applyDeepstate': VUEX_JOBS_APPLY_DEEPSTATE,
				'showOverlay'      : VUEX_UI_SHOW_QUICK_FILTER_OVERLAY,
				'hideOverlay'      : VUEX_UI_HIDE_QUICK_FILTER_OVERLAY,

			}),
			toggleMenuOpenState() {
				if (this.mobile === true){
					(this.overlayOpenState === false) ? this.showOverlay() : this.hideOverlay()
				}
				if (this.mobile === false){
					this.openState = !this.openState
				}
				//APPCUES
                window.Appcues.track("Open Job Quick Filters");
			},
			removeCurrentQuickFilter() {
				this.selectedQuickFilter = null
                this.openState = false
			},
			setQuickFilter(item,noToggle)  {
                //CLEAR ALL EXISTING
                this.clearQuickFilters();

                //SET
				this.selectedQuickFilter = item.name
				this.applyQuickFilter(item)
                if (noToggle===false) {
                    this.toggleMenuOpenState()
                }

                //SET FILTER_TOGGLER
                this.$store.dispatch('VUEX_JOBS_SET_FILTER_TOGGLER', { value: "quick"})

			},

			quickFilterClass() {
				let filterClass = (this.mobile === false) ? "quick-filters" : "quick-filters-overlay";
				return filterClass
			},

            isManagers() {
			          //note - package approver is NOT a manager
                if (
                    this.currentUserHasRole(SILA_ROLE_JOBS_EXECUTIVE)
                    || this.currentUserHasRole(SILA_ROLE_JOBS_PRINT_APPROVER)
                    || this.currentUserHasRole(SILA_ROLE_JOBS_PROJECT_MANAGER)
                    || this.currentUserHasRole(SILA_ROLE_JOBS_PRINT_PROJECT_MANAGER)
                    || this.currentUserHasRole(SILA_ROLE_JOBS_PREMEDIA_PROJECT_MANAGER)
                ) {
                    return true
                } else {
                    return false
                }

            },

            //determine the default quick filter and apply it
            applyDefaultQuickFilter() {
                //set current
                if (this.$router.currentRoute.name === 'jobs-manage') {
                    //manage
                    //Default for role SILA_ROLE_JOBS_PRINT_PROJECT_MANAGER is In Production
                    //Default for all others is active
                    if (this.currentUserHasRole(SILA_ROLE_JOBS_PRINT_PROJECT_MANAGER)) {
                        this.setQuickFilter({
                            name: 'In Production',
                            value: 3
                        }, true)
                    } else {
                        this.setQuickFilter({
                            name: 'Active',
                            value: 1
                        }, true)
                    }
                } else {
                    //request
                    //Default for role SILA_ROLE_JOBS_EXECUTIVE is Pending Approval
                    //Default for role SILA_ROLE_JOBS_PRINT_PROJECT_MANAGER is Pending Print Approval
                    //Default for all others is All My Requests
                    if (this.currentUserHasRole(SILA_ROLE_JOBS_EXECUTIVE)) {
                        this.setQuickFilter({
                            name: 'Pending Approval',
                            value: 7
                        }, true)
                    } else if (this.currentUserHasRole(SILA_ROLE_JOBS_PRINT_APPROVER)) {
                        this.setQuickFilter({
                            name: 'Pending Print Approval',
                            value: 8
                        }, true)
                    } else if (this.currentUserHasRole(SILA_ROLE_JOBS_PACKAGE_APPROVER)) {
                        this.setQuickFilter({
                            name: 'Pending Package Approval',
                            value: 12
                        }, true)
                    } else {
                        if ( this.isManagers() ) {
                            //EXECS
                            this.setQuickFilter({
                                name: 'All Requests',
                                value: 11
                            }, true)
                        } else {
                            //ALL ELSE
                            this.setQuickFilter({
                                name: 'All My Requests',
                                value: 9
                            }, true)
                        }

                    }
                }
            },

            //clear search terms - apply the default quick filter
            clearSearchTerms() {
			    this.applyDefaultQuickFilter()
            },
            getSearchTerms() {
			    let ret = ''
                let idx = this.appliedFilters.findIndex(x => x.filterOn === 'searchTerms')
                if (idx > -1) {
                    ret = this.appliedFilters[idx]['value']
                }
                return ret
            },

		},

	}
</script>
